<template>
  <div class="Upload-box Upload1 target-box" v-if="videoOpen">
    <div class="close" @click="closeDialog">
      X
      <!-- <img src="https://www.yasubit.com/template/pc/skin/images/icon43.png" alt="" /> -->
    </div>
    <!-- <div class="close" @click="closeDialog">
      <img src="https://www.yasubit.com/template/pc/skin/images/icon43.png" alt="" />
    </div> -->
    <!-- <div class="zoomx z1" @click="minimizeDialog">-</div> -->
    <div class="box" id="f_uplo1">
      <div class="list">
        <ul id="demoList">
          <li class="title">
            <div class="t1">{{ $t('message.fileName') }}</div>
            <div class="t2">{{ $t('message.originalFileSize') }}</div>
            <div class="t3">{{ $t('message.status') }}</div>
            <div class="t4">{{ $t('message.compressedFileSize') }}</div>
            <div class="t6">{{ $t('message.fileSizeReduced') }}</div>
            <div class="t5">{{ $t('message.action') }}</div>
          </li>
          <li v-for="(item, index) in videoDataList" :key="index">
            <div class="t1">
              <img src="https://www.yasubit.com/template/pc/skin/images/icon10.png" alt="" /><span>{{ item.fileName
                }}<span></span></span>
            </div>
            <div class="t2">
              {{ (item.size / (1024 * 1024)).toFixed(2) + " MB" }}
            </div>
            <div class="t3">
              <div class="layui-progress" lay-filter="progress-demo-1705310614597-0">
                <div class="layui-progress-bar" :lay-percent="item.progress + '%'"
                  :style="{ width: item.progress + '%' }"></div>
              </div>
            </div>
            <div class="t4">
              <span v-if="item.compSize">{{ (item.compSize / (1024 * 1024)).toFixed(2) + " MB" }}</span>
              <span v-else> {{ " " }}</span>
            </div>
            <div class="t6" style="color: rgb(95, 184, 120)">
              <span v-if="item.compSize && item.origSize">{{ ((1 - item.compSize / item.origSize) * 100).toFixed(2) +
    "%" }}</span>
              <span v-else> {{ " " }}</span>
            </div>
            <div class="t5">
              <span class="s1" @click="deleteVideo(index)">{{ $t('message.delete') }}</span>
              <span v-if="item.isUploading" class="s3" @click="togglePause(index)">
                {{ item.isPaused ? $t('message.resume') : $t('message.pause') }}
              </span>
              <span v-if="status === 2 && compressionStatus === 'DONE'" download="" class="s2" style="cursor: pointer"
                @click="downloadVideo(index)">{{ $t('message.download') }}</span>
              <span v-else>{{ " " }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="ckbox">
        <div class="cc1">
          <div class="check" v-if="status !== 2">
            <span><img src="https://www.yasubit.com/template/pc/skin/images/icon12.png" alt="" /></span>
            {{ $t('message.clickOrDragToAddVideo') }}
            <el-upload :class="['c4', status === 2 ? 'custom-upload' : 'custom-upload']" drag action="" ref="uploadRef"
              multiple accept=".mp4,.avi,.mov,.wmv,.flv,.mkv" :show-file-list="false" :auto-upload="false"
              :on-change="handleFileChange" :on-drop="handleMultipleFiles" :trigger="'click'">
              <div class="upload-trigger">
                <div class="check">
                  <span><img src="https://www.yasubit.com/template/pc/skin/images/icon12.png" alt="" /></span>
                  <span v-if="status !== 2">{{ $t('message.clickOrDragToAddVideo') }}</span>
                  <span v-else>{{ $t('message.continueToAddVideo') }}</span>
                </div>
              </div>
            </el-upload>
          </div>
          <div class="check" v-else>
            <span><img src="https://www.yasubit.com/template/pc/skin/images/icon12.png" alt="" /></span>
            {{ $t('message.continueToAddVideo') }}
            <el-upload :class="['c4', status === 2 ? 'custom-upload' : 'custom-upload']" drag action="" ref="uploadRef"
              multiple accept=".mp4,.avi,.mov,.wmv,.flv,.mkv" :show-file-list="false" :auto-upload="false"
              :on-change="handleFileChange" :on-drop="handleMultipleFiles" :trigger="'click'">
              <div class="upload-trigger">
                <div class="check">
                  <span><img src="https://www.yasubit.com/template/pc/skin/images/icon12.png" alt="" /></span>
                  <span v-if="status !== 2">{{ $t('message.clickOrDragToAddVideo') }}</span>
                  <span v-else>{{ $t('message.continueToAddVideo') }}</span>
                </div>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="ckbox2">
        <div class="left">
          共上传<span class="shu1">{{ videoDataList.length }}</span>视频
        </div>
        <div class="right">
          <div v-if="status === 0" class="start disable" id="video_tijiao">
            {{ $t('message.startCompress') }}
          </div>
          <div v-if="status === 1" class="start uploading" id="video_tijiao">
            {{ $t('message.uploading') }}
          </div>
          <div v-if="status === 2 && compressionStatus === 'COMPRESSING'" class="start compressing" id="video_tijiao">
            {{ $t('message.compressing') }}
          </div>
          <div v-if="status === 2 && compressionStatus === 'DONE'" @click="downloadAll" class="start"
            style="background-color: #5fb878 !important" id="video_downloadAll">
            {{ $t('message.downloadAll')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import axios from "axios";
import { ImprovedVideoChunkUploader } from '@/utils/improved-video-chunk-uploader';
import JSZip from 'jszip';
import { getUploadConfig, getUserLimits, isSupportedFile } from '@/config/upload-config';

export default {
  props: {
    videoOpen: Boolean
  },
  data() {
    return {
      videoDataList: [], // { fileName, size, progress, compression, isUploading, isPaused, uploadId }
      status: 0, // 0: initial, 1: uploading, 2: finished
      videoChunkUploader: null,
      userId: null,
      compressionStatus: '', // 新增压缩状态
      isGuest: true,
    };
  },
  async mounted() {
    // Get user info first
    const userInfo = await this.getUserInfo();

    // 获取全局baseURL
    const baseURL = this.$http.defaults.baseURL.replace(/\/$/, '');
    const sliceUrl = '/yasubit/upload/slice';
    const statusUrl = '/yasubit/upload/task/status';

    if (userInfo) {
      this.userId = userInfo.usersId;
      this.isGuest = false;
    } else {
      // For guest users, generate a temporary ID
      this.userId = 'guest-' + Math.random().toString(36).substring(2, 15);
      this.isGuest = true;
    }

    const config = getUploadConfig('video');
    this.videoChunkUploader = new ImprovedVideoChunkUploader({
      sliceUrl,
      statusUrl,
      userId: this.userId,
      chunkSize: config.chunkSize,
      maxConcurrent: config.maxConcurrent,
      retryDelay: config.retryDelay,
      maxRetries: config.maxRetries,
      pollInterval: config.pollInterval
    });
  },
  methods: {
    closeDialog() {
      this.videoDataList = [];
      this.status = 0;
      this.$emit('close');
    },
    minimizeDialog() {
      this.$emit('minimize');
    },
    isFinish() {
      console.warn("isFinish method called - review if still needed with chunk uploader");
    },
    getToken() {
      return localStorage.getItem("loginToken");
    },
    async getUserInfo() {
      const token = localStorage.getItem("loginToken");
      if (!token) {
        // this.$message.warning("请先登录");
        return null;
      }

      const headers = { Authorization: `Bearer ${token}` };
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.headers = headers;
      }

      try {
        const response = await this.$http.get("yasubit/users/info", { headers });
        if (response.data.code !== 200) {
          // this.$message.error(response.data.msg || "获取用户信息失败");
          return null;
        }
        return response.data.data;
      } catch (error) {
        console.error("Error fetching user info:", error);
        // this.$message.error("获取用户信息失败");
        return null;
      }
    },
    downloadVideo(index) {
      const row = this.videoDataList[index];
      if (!row || !row.compUrl) {
        this.$message.error(this.$t('message.downloadFailed') + ': Invalid file URL');
        return;
      }
      const videoUrl = this.getFullVideoUrl(row.compUrl);

      try {
        const downloadLink = document.createElement("a");
        // 直接将可访问的 URL 赋给 href
        downloadLink.href = videoUrl;
        // download 属性指示浏览器下载文件，而不是导航到它
        downloadLink.download = row.fileName;

        // 为了更好的兼容性和处理跨域问题，可以考虑将 a 标签的 target 设置为 '_blank'
        // downloadLink.target = '_blank';

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        console.error('Download trigger failed:', error);
        this.$message.error(this.$t('message.downloadFailed'));
      }
    },
    async downloadVideo(index) {
      const row = this.videoDataList[index];
      if (!row || !row.compUrl) {
        this.$message.error(this.$t('message.downloadFailed'));
        return;
      }

      try {
        const link = document.createElement("a");
        link.href = this.$fileBaseURL + row.compUrl;  // 拼接完整地址
        link.download = row.fileName || "download.mp4"; // 指定下载文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Video download failed:", error);
        this.$message.error(this.$t('message.downloadFailed'));
      }
    }
    ,
    async downloadAll() {
      try {
        const filePaths = this.videoDataList
          .filter(row => row.compUrl)
          .map(row => row.compUrl);

        if (filePaths.length === 0) {
          this.$message.warning(this.$t('message.noDownloadableFiles'));
          return;
        }
        this.$message.info(this.$t('message.startDownloading'));
        const response = await axios.post('/yasubit/download/zip', filePaths, {
          responseType: 'blob',
          timeout: 0
        });

        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Yasubit-${new Date().toISOString().replace(/[:.-]/g, "").substring(0, 15)}.zip`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$message.error(this.$t('message.createZipFailed'));
      }
    }
    ,
    async handleFileChange(file, fileList) {
      if (!file) return;

      if (!this.videoChunkUploader) {
        this.$message.error(this.$t('message.uploadComponentInitFailed'));
        this.$refs.uploadRef.handleRemove(file);
        return;
      }

      // 校验视频后缀名
      const allowedExts = ['y4m', 'yuv', 'avi', 'flv', 'mp4', 'mov', 'ts', 'mkv'];
      const ext = file.name.split('.').pop().toLowerCase();
      if (!allowedExts.includes(ext)) {
        this.$message.error(this.$t('message.unsupportedVideoFormat') || '不支持的视频格式');
        this.$refs.uploadRef.handleRemove(file);
        return;
      }

      if (!this.videoChunkUploader) {
        this.$message.error(this.$t('message.uploadComponentInitFailed'));
        this.$refs.uploadRef.handleRemove(file);
        return;
      }

      // Guest user validation
      if (this.isGuest) {
        if (this.videoDataList.length >= 1) {
          this.$message.error(this.$t('message.guestVideoMaxUpload'));
          this.$refs.uploadRef.handleRemove(file);
          return;
        }
        if (file.raw.size > 60 * 1024 * 1024) {
          this.$message.error(this.$t('message.guestVideoSizeLimit'));
          this.$refs.uploadRef.handleRemove(file);
          return;
        }
      }

      this.status = 1;

      if (this.videoDataList.find((item) => item.fileName === file.name)) {
        this.$message.error(this.$t('message.videoAlreadyExists'));
        this.$refs.uploadRef.handleRemove(file);
        return;
      }

      const uploadId = await this.videoChunkUploader.createUploadTask(file.name, file.size);

      this.videoDataList.push({
        fileName: file.name,
        size: file.size,
        progress: 0,
        compression: 0,
        isUploading: true,
        isPaused: false,
        compUrl: '',
        origUrl: '',
        uploadId: uploadId
      });

      try {
        const result = await this.videoChunkUploader.upload(file.raw, (percent) => {
          const fileIndex = this.videoDataList.findIndex(item => item.fileName === file.name);
          if (fileIndex !== -1) {
            this.$set(this.videoDataList[fileIndex], 'progress', percent);
          }
        }, uploadId, (status, data) => {
          // 更新压缩状态和文件大小信息
          this.compressionStatus = status;
          if (status === 'COMPRESSING') {
            this.status = 2;
          }
          // 更新文件大小信息
          const fileIndex = this.videoDataList.findIndex(item => item.fileName === file.name);
          if (fileIndex !== -1 && data) {
            this.$set(this.videoDataList[fileIndex], 'origSize', data.origSize);
            this.$set(this.videoDataList[fileIndex], 'compSize', data.compSize);
          }
        });

        const fileIndex = this.videoDataList.findIndex(item => item.fileName === file.name);
        if (fileIndex !== -1) {
          this.$set(this.videoDataList[fileIndex], 'isUploading', false);
          this.$set(this.videoDataList[fileIndex], 'finish', true);
          this.$set(this.videoDataList[fileIndex], 'compUrl', result.compressionSize);
          this.$set(this.videoDataList[fileIndex], 'origUrl', result.originalSize);
          this.$set(this.videoDataList[fileIndex], 'origSize', result.origSize);
          this.$set(this.videoDataList[fileIndex], 'compSize', result.compSize);
        }
        this.checkAllUploadsFinished();
      } catch (error) {
        console.error(`Upload for ${file.name} failed:`, error);
        const fileIndex = this.videoDataList.findIndex(item => item.fileName === file.name);
        if (fileIndex !== -1) {
          this.$set(this.videoDataList[fileIndex], 'isUploading', false);
          this.$set(this.videoDataList[fileIndex], 'error', true);
          this.$message.error(this.$t('message.uploadFailed', { name: file.name, msg: error.message || this.$t('message.unknownError') }));
        }
        this.checkAllUploadsFinished();
      }
    },
    checkAllUploadsFinished() {
      const allFinished = this.videoDataList.every(item => item.isUploading === false);
      if (allFinished) {
        this.status = 2;
        console.log("All uploads completed.");
      }
    },
    async handleMultipleFiles(files) {
      if (!files || !files.length) return;

      if (!this.videoChunkUploader) {
        this.$message.error(this.$t('message.uploadComponentInitFailed'));
        return;
      }

      // 校验后缀名
      const allowedExts = ['y4m', 'yuv', 'avi', 'flv', 'mp4', 'mov', 'ts', 'mkv'];
      const validFiles = files.filter(file => {
        const ext = file.name.split('.').pop().toLowerCase();
        if (!allowedExts.includes(ext)) {
          this.$message.error(this.$t('message.unsupportedVideoFormat') || '不支持的视频格式: ' + file.name);
          return false;
        }
        return true;
      });

      this.status = 1;

      const newFiles = files.filter(file =>
        !this.videoDataList.find(item => item.fileName === file.name)
      );

      if (newFiles.length === 0) {
        this.$message.warning(this.$t('message.allFilesExist'));
        return;
      }

      // Guest user validation
      if (this.isGuest) {
        if (this.videoDataList.length + newFiles.length > 1) {
          this.$message.error(this.$t('message.guestVideoMaxUpload'));
          return;
        }

        for (const file of newFiles) {
          if (file.size > 60 * 1024 * 1024) {
            this.$message.error(this.$t('message.guestVideoSizeLimit'));
            return;
          }
        }
      }

      for (const file of newFiles) {
        this.videoDataList.push({
          fileName: file.name,
          size: file.size,
          progress: 0,
          compression: 0,
          isUploading: true,
          isPaused: false,
          compUrl: '',
          origUrl: '',
          uploadId: ''
        });

        try {
          const uploadId = await this.videoChunkUploader.createUploadTask(file.name, file.size);
          const result = await this.videoChunkUploader.upload(file, (percent) => {
            const fileIndex = this.videoDataList.findIndex(item => item.fileName === file.name);
            if (fileIndex !== -1) {
              this.$set(this.videoDataList[fileIndex], 'progress', percent);
            }
          }, uploadId);

          const fileIndex = this.videoDataList.findIndex(item => item.fileName === file.name);
          if (fileIndex !== -1) {
            this.$set(this.videoDataList[fileIndex], 'isUploading', false);
            this.$set(this.videoDataList[fileIndex], 'finish', true);
            this.$set(this.videoDataList[fileIndex], 'compUrl', result.compressionSize);
            this.$set(this.videoDataList[fileIndex], 'origUrl', result.originalSize);
            const compressionSize = result.compressionSize.split('/').pop();
            this.$set(this.videoDataList[fileIndex], 'compression', compressionSize);
            this.$set(this.videoDataList[fileIndex], 'uploadId', uploadId);
          }
        } catch (error) {
          console.error(`Upload for ${file.name} failed:`, error);
          const fileIndex = this.videoDataList.findIndex(item => item.fileName === file.name);
          if (fileIndex !== -1) {
            this.$set(this.videoDataList[fileIndex], 'isUploading', false);
            this.$set(this.videoDataList[fileIndex], 'error', true);
            this.$message.error(this.$t('message.uploadFailed', { name: file.name, msg: error.message || this.$t('message.unknownError') }));
          }
        }
      }

      this.checkAllUploadsFinished();
    },
    getFullVideoUrl(relativePath) {
      // 直接拼接指定的下载前缀
      return this.$fileBaseURL + relativePath;
    },
    triggerUpload() {
      this.$refs.uploadRef.$el.querySelector('input[type="file"]').click();
    },
    async togglePause(index) {
      const item = this.videoDataList[index];
      if (!item) return;

      if (item.isPaused) {
        // Resume upload
        try {
          await this.videoChunkUploader.resumeUpload(item.uploadId, (percent) => {
            this.$set(this.videoDataList[index], 'progress', percent);
          });
          this.$set(this.videoDataList[index], 'isPaused', false);
        } catch (error) {
          console.error('Failed to resume upload:', error);
          this.$message.error(this.$t('message.resumeUploadFailed'));
        }
      } else {
        // Pause upload
        try {
          await this.videoChunkUploader.pauseUpload(item.uploadId);
          this.$set(this.videoDataList[index], 'isPaused', true);
        } catch (error) {
          console.error('Failed to pause upload:', error);
          this.$message.error(this.$t('message.pauseUploadFailed'));
        }
      }
    },
    async _pollStatus(taskId) {
      const params = { taskId, userId: this.userId };
      while (true) {
        const response = await axios.get(this.statusUrl, { params });
        const { data } = response;

        // 更新压缩状态
        this.compressionStatus = data.data.status;

        // Check if the task is done based on the response format
        if (data.code === 200 && data.data.status === 'DONE') {
          // Clean up the upload task
          this.uploadTasks.delete(taskId);
          return {
            compressionSize: data.data.compUrl, // Return the compressed file URL
            originalSize: data.data.origUrl,    // Return the original file URL
            progress: data.data.progress,
            filename: data.data.filename
          };
        }

        // If there's an error in the response
        if (data.code !== 200) {
          throw new Error(data.msg || '视频压缩任务失败');
        }

        await new Promise(r => setTimeout(r, this.pollInterval));
      }
    },
  },
  watch: {
    videoDataList: {
      handler(newList) {
        if (newList.length === 0) {
          this.status = 0;
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.Upload-box {
  /* styles */
}

.Upload-box .box {
  /* styles */
}

.Upload-box .box .list li .t1 span {
  /* styles */
}

.cc1 {
  /* styles */
}

::v-deep .custom-upload .el-upload-dragger {
  /* styles */
}

::v-deep .none_upload .el-upload-dragger {
  /* styles */
}

.disable {
  /* styles */
}

.upload-trigger {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.upload-trigger .check {
  text-align: center;
  color: #666;
}

.upload-trigger .check span {
  display: block;
  margin-bottom: 10px;
}

.upload-trigger .check img {
  width: 48px;
  height: 48px;
}

.s3 {
  color: #409EFF;
  cursor: pointer;
  margin: 0 5px;
}

.s3:hover {
  color: #66b1ff;
}

.start {
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #409EFF;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.start:hover {
  background-color: #66b1ff;
}

.start.uploading {
  background-color: #E6A23C;
  cursor: not-allowed;
}

.start.compressing {
  background-color: #E6A23C;
  cursor: not-allowed;
}

.start.disable {
  background-color: #909399;
  cursor: not-allowed;
}
</style>